export const WATER_SERVICE_CONNECTIONS_BASE_URL = `${process.env.REACT_APP_ENDPOINT}/api/water-service-connection-management`;
export const LOOKUP_PWS_OPERATORS = `${WATER_SERVICE_CONNECTIONS_BASE_URL}/list-pws-operators`;

export const WATER_SERVICE_CONNECTION_PK_FIELD = "pws_connection_ndx";

export const COLUMNS = [
  {
    field: "pws_connection_ndx",
    headerName: "Connection ID",
    width: 100,
    editable: false,
    type: "number",
  },
  {
    field: "first_name",
    headerName: "First Name",
    width: 120,
    editable: true,
  },
  {
    field: "last_name",
    headerName: "Last Name",
    width: 120,
    editable: true,
  },
  {
    field: "role_owner",
    headerName: "Role: Owner",
    width: 100,
    editable: true,
    type: "boolean",
  },
  {
    field: "role_builder",
    headerName: "Role: Builder",
    width: 100,
    editable: true,
    type: "boolean",
  },
  {
    field: "company_name",
    headerName: "Company Name",
    width: 180,
    editable: true,
  },
  {
    field: "pws",
    headerName: "PWS Operator",
    width: 180,
    editable: true,
    type: "number",
  },
  {
    field: "street_address",
    headerName: "Service Address",
    width: 200,
    editable: true,
  },
  {
    field: "street_city",
    headerName: "Service City",
    width: 120,
    editable: true,
  },
  {
    field: "street_state",
    headerName: "Service State",
    width: 80,
    editable: true,
  },
  {
    field: "street_zip",
    headerName: "Service Zip",
    width: 100,
    editable: true,
  },
  {
    field: "street_subdivision",
    headerName: "Subdivision",
    width: 150,
    editable: true,
  },
  {
    field: "street_unit",
    headerName: "Unit",
    width: 80,
    editable: true,
  },
  {
    field: "mail_address",
    headerName: "Mailing Address",
    width: 200,
    editable: true,
  },
  {
    field: "mail_city",
    headerName: "Mailing City",
    width: 120,
    editable: true,
  },
  {
    field: "mail_state",
    headerName: "Mailing State",
    width: 80,
    editable: true,
  },
  {
    field: "mail_zip",
    headerName: "Mailing Zip",
    width: 100,
    editable: true,
  },
  {
    field: "mail_phone",
    headerName: "Phone",
    width: 120,
    editable: true,
  },
  {
    field: "mail_fax",
    headerName: "Fax",
    width: 120,
    editable: true,
  },
  {
    field: "street_email",
    headerName: "Email",
    width: 180,
    editable: true,
  },
  {
    field: "meter_size",
    headerName: "Meter Size",
    width: 100,
    editable: true,
  },
  {
    field: "date_of_connection",
    headerName: "Connection Date",
    editable: true,
    type: "date",
    valueGetter: (params) =>
      params && params.value ? new Date(params.value) : null,
    width: 150,
  },
  {
    field: "type_single_family",
    headerName: "Single Family",
    width: 110,
    editable: true,
    type: "boolean",
  },
  {
    field: "type_multifamily",
    headerName: "Multi-Family",
    width: 110,
    editable: true,
    type: "boolean",
  },
  {
    field: "type_rv_slip",
    headerName: "RV Slip",
    width: 90,
    editable: true,
    type: "boolean",
  },
  {
    field: "type_commercial",
    headerName: "Commercial",
    width: 110,
    editable: true,
    type: "boolean",
  },
  {
    field: "paid",
    headerName: "Payment Status",
    width: 120,
    editable: true,
  },
  {
    field: "check_number",
    headerName: "Check Number",
    width: 120,
    editable: true,
  },
  {
    field: "comments",
    headerName: "Comments",
    width: 200,
    editable: true,
  },
  {
    field: "dt_approved",
    headerName: "Approved Date",
    width: 150,
    editable: false,
    type: "date",
    valueGetter: (params) =>
      params && params.value ? new Date(params.value) : null,
  },
  {
    field: "approved_by_user",
    headerName: "Approved By",
    width: 150,
    editable: false,
  },
  {
    field: "date_received",
    headerName: "Date Received",
    width: 130,
    editable: true,
    type: "date",
    valueGetter: (params) =>
      params && params.value ? new Date(params.value) : null,
  },
  {
    field: "date_sent_receipt",
    headerName: "Receipt Sent Date",
    width: 150,
    editable: true,
    type: "date",
    valueGetter: (params) =>
      params && params.value ? new Date(params.value) : null,
  },
  {
    field: "applicant_acknowledge",
    headerName: "Applicant Acknowledged",
    width: 160,
    editable: true,
    type: "boolean",
  },
  {
    field: "applicant_signed_name",
    headerName: "Applicant Signed Name",
    width: 180,
    editable: true,
  },
  {
    field: "applicant_signed_date",
    headerName: "Applicant Signed Date",
    width: 160,
    editable: true,
    type: "date",
    valueGetter: (params) =>
      params && params.value ? new Date(params.value) : null,
  },
  {
    field: "entered_by",
    headerName: "Entered By",
    width: 150,
    editable: false,
  },
  {
    field: "authorized_by",
    headerName: "Authorized By",
    width: 150,
    editable: false,
  },
  {
    field: "date_entered",
    headerName: "Date Entered",
    width: 130,
    editable: false,
    type: "date",
    valueGetter: (params) =>
      params && params.value ? new Date(params.value) : null,
  },
  {
    field: "connection_approved",
    headerName: "Connection Approved",
    width: 150,
    editable: true,
    type: "boolean",
    renderCell: (params) => {
      if (params.value === null) return "Pending";
      return params.value ? "Approved" : "Denied";
    },
  },
  {
    field: "dt_denied",
    headerName: "Date Denied",
    width: 130,
    editable: false,
    type: "date",
    valueGetter: (params) =>
      params && params.value ? new Date(params.value) : null,
  },
  {
    field: "denied_by_user",
    headerName: "Denied By",
    width: 150,
    editable: false,
  },
];
